export const tagSlug = (tagId: string, page?: number) => `/blog/tags/${tagId}/${page || 1}`